<ui-modal
  class="user-pref"
  [isOpened]="isModalOpened"
  modalTitle="User Preferences"
  (isOpenedChange)="modalChanged($event)"
>
  <clr-accordion [clrAccordionMultiPanel]="true" class="user-pref__accordion">
    <clr-accordion-panel>
      <clr-accordion-title>Product Attribute Defaults</clr-accordion-title>
      <clr-accordion-content *clrIfExpanded>
        <form [formGroup]="form" autocomplete="off" class="user-pref__form">
          <div class="user-pref__row">
            <div class="user-pref__row__top-row-container">
              <div class="user-pref__col">
                <div class="user-pref__row">
                  <div
                    class="user-pref__input-container user-pref__input-container--product-attribute"
                  >
                    <label>
                      Product Attribute:
                      <app-selector
                        [isSearch]="true"
                        formControlName="productAttributes"
                        [passedItems]="productAttributes"
                      ></app-selector>
                    </label>
                  </div>
                  <div
                    class="user-pref__input-container user-pref__input-container--default-options"
                    *ngIf="attributeOptions"
                  >
                    <label>
                      Default Options:
                      <app-selector
                        [isSearch]="true"
                        formControlName="options"
                        [passedItems]="attributeOptions"
                      ></app-selector>
                    </label>
                  </div>
                  <div class="user-pref__row--button">
                    <button
                      class="icon-button icon-button__add"
                      (click)="addToDefaults()"
                    >
                      <img src="assets/plus-big.svg" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="user-pref__row">
                <clr-toggle-wrapper class="user-pref__toggle">
                  <input
                    type="checkbox"
                    clrToggle
                    (change)="useDefaultsToggleChange($event)"
                    formControlName="useDefaults"
                  />
                  <label>Use Defaults</label>
                </clr-toggle-wrapper>
              </div>
            </div>
          </div>
          <div class="user-pref__row" style="justify-content: center">
            <div class="user-pref__table-container">
              <table ui-table>
                <thead>
                  <tr>
                    <th>Attribute</th>
                    <th>Default</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let default of currentDefaults">
                    <td>
                      <div>
                        {{ default.key }}
                      </div>
                    </td>
                    <td>
                      <div>
                        {{ default.value }}
                      </div>
                    </td>
                    <td>
                      <div>
                        <button
                          class="ui-button icon-button"
                          (click)="removeFromDefaults(default)"
                        >
                          <img src="assets/cross.svg" />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </clr-accordion-content>
    </clr-accordion-panel>
    <clr-accordion-panel>
      <clr-accordion-title>Reporting Currency</clr-accordion-title>
      <clr-accordion-content *clrIfExpanded>
        <div class="user-pref__row">
          <div class="user-pref__col">
            <div class="user-pref__row">
              <div class="user-pref__input-container">
                <label>
                  Reporting Currency:
                  <app-selector
                    [isSearch]="true"
                    [passedItems]="currencies"
                    (valueEmitter)="changeInReportingCurrency($event.value)"
                    [defaultValue]="defaultReportingCurrency"
                  ></app-selector>
                </label>
              </div>
            </div>
          </div>
        </div>
      </clr-accordion-content>
    </clr-accordion-panel>

    <clr-accordion-panel>
      <clr-accordion-title>Legs pricing results</clr-accordion-title>
      <clr-accordion-content *clrIfExpanded>
        <div class="pd-grid">
          <div *ngFor="let section of pricingDisplayPrefs">
            <h3>{{ section.header }}</h3>
            <div class="pd-grid__items">
              <div class="pd-grid__item" *ngFor="let item of section.options">
                <label>
                  <input
                    type="checkbox"
                    width="1rem"
                    (click)="updatePricingDisplaySettings(item.shortName)"
                    [ngModel]="pricingDisplaySettings[item.shortName]"
                  />
                  {{ item.longName }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </clr-accordion-content>
    </clr-accordion-panel>

    <clr-accordion-panel>
      <clr-accordion-title>Trade statuses</clr-accordion-title>
      <clr-accordion-content *clrIfExpanded>
        <p>Statuses to show in Trades tab in the Positions panel.</p>
        <form [formGroup]="tradeStatusesForm" class="pd-grid">
          <div class="pd-grid__items">
            @for (
              ctrl of tradeStatusesForm.controls | keyvalue: orderOriginal;
              track $index
            ) {
              <div class="pd-grid__item">
                <label>
                  <input
                    type="checkbox"
                    style="width: 1rem"
                    [formControlName]="ctrl.key"
                  />
                  {{ tradeStatusNames[ctrl.key] }}
                </label>
              </div>
            }
          </div>
        </form>
        <p>
          After changing values, you will need to press the Update button in the
          Trades tab to apply the filter.
        </p>
      </clr-accordion-content>
    </clr-accordion-panel>

    <clr-accordion-panel>
      <clr-accordion-title>Other</clr-accordion-title>
      <clr-accordion-content *clrIfExpanded>
        <form [formGroup]="soundForm">
          <div class="sound-form">
            <label>
              <input type="checkbox" width="1rem" formControlName="sounds" />
              Enable sound notifications
            </label>
            <div class="clr-form-control">
              <div class="clr-control-container clr-control-inline">
                <div class="clr-radio-wrapper">
                  <input
                    formControlName="soundLevel"
                    type="radio"
                    id="sound-level-quiet"
                    value="quiet"
                    class="clr-radio"
                  />
                  <label for="sound-level-quiet" class="clr-control-label">
                    Quiet
                  </label>
                </div>
                <div class="clr-radio-wrapper">
                  <input
                    formControlName="soundLevel"
                    type="radio"
                    id="sound-level-medium"
                    value="medium"
                    class="clr-radio"
                  />
                  <label for="sound-level-medium" class="clr-control-label">
                    Medium
                  </label>
                </div>
                <div class="clr-radio-wrapper">
                  <input
                    formControlName="soundLevel"
                    type="radio"
                    id="sound-level-loud"
                    value="loud"
                    class="clr-radio"
                  />
                  <label for="sound-level-loud" class="clr-control-label">
                    Loud
                  </label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </clr-accordion-content>
    </clr-accordion-panel>
  </clr-accordion>
</ui-modal>
